import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "view-job-address-modal",
  "data-toggle": "modal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "view-address-modal-label"
  }, "Job address"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_5 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex align-items-center mb-2"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "bullet me-3" }, null, -1)
const _hoisted_9 = { class: "text-gray-600 fw-bold fs-7" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Venue: ")
const _hoisted_11 = { class: "d-flex align-items-center mb-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "bullet me-3" }, null, -1)
const _hoisted_13 = { class: "text-gray-600 fw-bold fs-7" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Address: ")
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-light",
    "data-bs-dismiss": "modal"
  }, " Close ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.payload)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.payload.venue)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("span", null, _toDisplayString(_ctx.payload.venue.name ? _ctx.payload.venue.name : "") + ", " + _toDisplayString(_ctx.payload.venue.entrance ? _ctx.payload.venue.entrance : ""), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    (_ctx.payload.address)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.payload.address), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_16
      ])
    ])
  ]))
}